import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Header = ({ title, isHovered }) => {
  const underScoreTitleRef = useRef();
  const titleRef = useRef();

  useEffect(() => {
    if (isHovered) {
      titleRef.current.classList.add('hover');
      underScoreTitleRef.current.classList.add('hover');
    } else {
      titleRef.current.classList.remove('hover');
      underScoreTitleRef.current.classList.remove('hover');
    }
  }, [isHovered]);

  return (
    <div className="service-card-header">
      <div className="service-card-title-wrapper">
        <div ref={titleRef} className="service-card-home-title">
          {title}
        </div>
        <div
          ref={underScoreTitleRef}
          className="service-card-title-underscore"
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  isHovered: PropTypes.bool,
  disableCard: PropTypes.func,
};

export default Header;
